import GameStatesEnum from "../GameStatesEnum"
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Config from "../../config/Config";
import Facade from "@/Facade";

export default class ShowWinningsState extends BaseState {

  begin() {
    window.force_coin_amount = null
      console.log('  sws  begin ')
    if(Facade.model.bigWin) {
      Signals.showBigWinComplete.addOnce(this.end, this)
    } else {
      //Signals.showWinningsComplete.addOnce (this.end, this)
        Signals.winsCountupComplete.addOnce (this.end, this)
    }
    Signals.hideCountingUpWinnings.addOnce(this.skipWinnings, this)
  //  Signals.spinBtnPressed.addOnce(this.skip, this)
   // Signals.startShowWinnings.dispatch({winnings: this.model.winnings, bonus: this.model.bonus, totalWin:
      // this.model.totalWin, isCycled: false})
    this.countUp()
  }

  countUp() {
      const startWin = Facade.model.totalWinOld
      const totalWin = Facade.model.isFreespinsMode ? this.model.winCurrencyFreespins : this.model.totalWin
    //const totalWin = this.model.totalWin
    const bigWin = Facade.model.bigWin
    const requireCounting = this.model.totalWin >= Config.MIN_COUNTUP_WIN * Facade.model._totalBetNumber
      Signals.startCountingUpWinnings.dispatch({startWin: startWin, winnings: totalWin, requireCounting: requireCounting, bigwin: bigWin})

      /*
         if(this.model.stateSkipped && !bigWin) {
             console.log('!!!!!!!!!  1  startWin ',startWin,'  totalWin ', totalWin, bigWin, this.requireCountin)
             Signals.startCountingUpWinnings.dispatch({startWin: startWin, winnings: totalWin, requireCounting: requireCounting, bigwin: bigWin})
           //this.end ()
           return
          }
          this.requireCounting = this.model.totalWin >= Config.MIN_COUNTUP_WIN * Facade.model._totalBetNumber

          const time = bigWin ? 1400 : 200
          this.timeoutWaitBigWin = setTimeout (() => {
              console.log('!!!!!!!!!  2  startWin ',startWin,'  totalWin ', totalWin, bigWin, this.requireCountin)
              Signals.startCountingUpWinnings.dispatch({startWin: startWin, winnings: totalWin, requireCounting: this.requireCounting, bigwin: bigWin})
          }, time)

       */
  }

  end = () => {
      console.log('  sws  end ')
   // this.gameState = GameStatesEnum.SHOW_CYCLEWINNINGS
   // if(this.model.isAuto || this.model.freespins || this.model.isFreespinsMode || this.model.isBonusStarted) {
     /// this.model.totalWin = 0
      this.model.scatters = false
      this.model.stateSkippedWinnings = true
      this.model.bonus.freebetCount = 0
      this.model.winnings = null
      this.gameState = GameStatesEnum.FINAL
  //  }

    this.stateMachine.setState(this.gameState)
  }

  skipWinnings(){

    // todo check stateSkippedWinnings
    ///  this.model.stateSkippedWinnings = true
    this.end();
  }

  skip() {
      const startWin = Facade.model.totalWinOld
      const totalWin = Facade.model.isFreespinsMode ? this.model.winCurrencyFreespins : this.model.totalWin

      if(Facade.model.bigWin) {
        clearTimeout(this.timeoutWaitBigWin)
        console.log('!!!!!!!!!  3 ')
        Signals.startCountingUpWinnings.dispatch({startWin: startWin,winnings: totalWin, requireCounting: this.requireCounting, bigwin: Facade.model.bigWin})
      return
    }
    this.model.stateSkipped = true
    Signals.skip.dispatch()
  }

  cleanUp() {
    Signals.showBigWinComplete.remove(this.end, this)
    Signals.showWinningsComplete.remove(this.end, this)
    Signals.spinBtnPressed.remove(this.skip, this)
      Signals.hideCountingUpWinnings.remove(this.skipWinnings, this)
  }
}